import * as React from 'react'
import { useSelector } from 'react-redux'
import { Redirect } from 'react-router'
import Splash from '../components/Splash'
import useThunkDispatch from '../common/useThunkDispatch'
import { IUser, STORAGE_USER_TOKEN_KEY } from '../types/user'
import { currentUserSelector } from './authSelectors'
import { requestCurrentUser } from './authActions'
import { requestManagerBranches } from '../manager/managerActions'
import TermsAndConditions from './TermsAndConditions'
import NoBranches from './NoBranches'
import { managerBranchesSelector } from '../manager/managerSelectors'

interface IOwnProps {
  children: (user: IUser) => any
}

const Auth = ({ children }: IOwnProps) => {
  const token = localStorage.getItem(STORAGE_USER_TOKEN_KEY)
  const user = useSelector(currentUserSelector)
  const dispatch = useThunkDispatch()

  const branches = useSelector(managerBranchesSelector)
  const [branchesLoaded, setBranchesLoaded] = React.useState(false)

  const init = async () => {
    if (token && !user) dispatch(requestCurrentUser())
  }

  React.useEffect(() => {
    if (user?.role !== 'manager') return
    dispatch(requestManagerBranches()).then(() => setBranchesLoaded(true))
  }, [user?.role])

  React.useEffect(() => {
    init()
  }, [])

  React.useEffect(() => {
    const handleCartInvalidated = (event: MessageEvent) => {
      if (event.data?.type === 'CART_INVALIDATED') {
        dispatch(requestManagerBranches())
      }
    }

    window.addEventListener('message', handleCartInvalidated)
    return () => window.removeEventListener('message', handleCartInvalidated)
  }, [dispatch])

  if (!token) return <Redirect to="/login" />

  if (!user) return <Splash isLoading={true} />

  if (!user.termsAcceptedAt) return <TermsAndConditions />

  // Branch pages can't render without a branch; show a way out instead of an endless splash
  if (user.role === 'manager' && branchesLoaded && !branches.length) {
    return <NoBranches />
  }

  return children(user)
}

export default Auth
